export enum OFFER_TRANSPARENCY {
  OFF = 'OFF',
  MULTIPLE = 'MULTIPLE',
  COUNT = 'COUNT',
}
